import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input, Button } from 'loyal-react'
import { genderTypes } from 'Participant'
import moment from 'moment'
import { validate as validateCPF } from 'gerador-validador-cpf'

class ProfileInfos extends Component {
  state = {
    isValid: true,
    name: this.props.participant.name,
    cpf: this.props.participant.cpf,
    email: this.props.participant.email,
    birthDate: this.props.participant.birthDate,
    phone: {
      value: this.props.participant.phones.home.number
        ? `${this.props.participant.phones.home.areaCode}${this.props.participant.phones.home.number}`
        : '',
      disabled: this.props.participant.phones.home.disabled
    },
    mobilePhone: {
      value: `${this.props.participant.phones.mobile.areaCode}${this.props.participant.phones.mobile.number}`,
      disabled: this.props.participant.phones.mobile.disabled
    }
  }

  componentDidMount () {
    this.isValid()
  }

  isValid = () => {
    let isValid = true
    const mailValidator = /^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+)$/gim
    const { name, cpf, email, birthDate, mobilePhone } = this.state

    if (!name.value) {
      this.setState({
        name: {
          value: name.value,
          disabled: name.disabled,
          error: 'Digite seu nome'
        }
      })
      isValid = false
    }

    if (!validateCPF(cpf.value)) {
      this.setState({
        cpf: {
          value: cpf.value,
          disabled: cpf.disabled,
          error: 'Digite um CPF válido'
        }
      })
      isValid = false
    }

    if (!mailValidator.test(email.value)) {
      this.setState({
        email: {
          value: email.value,
          disabled: email.disabled,
          error: 'Digite um e-mail válido'
        }
      })
      isValid = false
    }

    const birthDateVerify = moment(birthDate.value, 'DD/MM/YYYY', true)
    if (!birthDateVerify.isValid()) {
      this.setState({
        birthDate: {
          value: birthDate.value,
          disabled: birthDate.disabled,
          error: 'Digite uma data de nascimento válida'
        }
      })
      isValid = false
    }

    if (!mobilePhone.value) {
      this.setState({
        mobilePhone: {
          value: mobilePhone.value,
          disabled: mobilePhone.disabled,
          error: 'Digite um celular válido'
        }
      })
      isValid = false
    }
    this.setState({ isValid })
    return isValid
  }

  handleConfirm = () => {
    if (!this.isValid()) return

    const { buildPhone, setCustomer, participant } = this.props
    const { name, cpf, email, phone, birthDate, mobilePhone } = this.state

    let phones = [buildPhone(mobilePhone.value, 'MOBILE')]
    if (phone.value) {
      phones.push(buildPhone(phone.value, 'HOME'))
    }

    const customer = {
      name: name.value,
      documentNumber: cpf.value,
      email: email.value,
      genderType: genderTypes[participant.genderType.value],
      personType: 'INDIVIDUAL',
      birthDate: moment(birthDate.value, 'DD/MM/YYYY').format('YYYY/MM/DD'),
      phones
    }
    setCustomer(customer)
  }

  handleInputValid (input) {
    if (input.error) return false

    return null
  }

  handleInputChange = event => {
    this.setState({
      [event.target.name]: { value: event.target.value }
    })
  }

  render () {
    return (
      <div className='row px-0 pb-2 border-bottom border-color-ui-3 bg-ui-5'>
        <div className='profile-infos col-12 px-2'>
          <div className='row mx-0'>
            <Input
              id='input-name-profile-data'
              label='Nome'
              className='col-12 col-md-6 mt-2'
              minLength='1'
              maxLength='50'
              name='name'
              required
              data-error={this.state.name.error}
              valid={this.handleInputValid(this.state.name)}
              onChange={this.handleInputChange}
              value={this.state.name.value}
              disabled={this.state.name.disabled === 'true'}
              onBlur={this.isValid}
            />

            <Input
              id='input-cpf-profile-data'
              label='CPF'
              className='col-12 col-md-6 mt-2'
              required
              mask={[
                /\d/,
                /\d/,
                /\d/,
                '.',
                /\d/,
                /\d/,
                /\d/,
                '.',
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/
              ]}
              name='cpf'
              data-error={this.state.cpf.error}
              valid={this.handleInputValid(this.state.cpf)}
              onChange={this.handleInputChange}
              value={this.state.cpf.value}
              disabled={this.state.cpf.disabled === 'true'}
              onBlur={this.isValid}
            />

            <Input
              id='input-email-profile-data'
              label='E-mail'
              className='col-12 col-md-6 mt-2'
              required
              name='email'
              data-error={this.state.email.error}
              valid={this.handleInputValid(this.state.email)}
              onChange={this.handleInputChange}
              value={this.state.email.value}
              disabled={this.state.email.disabled === 'true'}
              onBlur={this.isValid}
            />

            <Input
              id='input-birthDate-profile-data'
              label='Data de nascimento'
              className='col-12 col-md-6 mt-2'
              required
              name='birthDate'
              mask={[
                /[0-3]/,
                /[0-9]/,
                '/',
                /[0-1]/,
                /[0-9]/,
                '/',
                /[1-2]/,
                /[0-9]/,
                /[0-9]/,
                /[0-9]/
              ]}
              data-error={this.state.birthDate.error}
              valid={this.handleInputValid(this.state.birthDate)}
              onChange={this.handleInputChange}
              value={this.state.birthDate.value}
              disabled={this.state.birthDate.disabled === 'true'}
              onBlur={this.isValid}
            />

            <Input
              id='input-mobilePhone-profile-data'
              label='Celular'
              className='col-12 col-md-6 mt-2'
              required
              mask={[
                '(',
                /[1-9]/,
                /\d/,
                ')',
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/,
                /\d/,
                /\d/
              ]}
              data-error={this.state.mobilePhone.error}
              valid={this.handleInputValid(this.state.mobilePhone)}
              onChange={this.handleInputChange}
              name='mobilePhone'
              value={this.state.mobilePhone.value}
              disabled={this.state.mobilePhone.disabled === 'true'}
              onBlur={this.isValid}
            />

            <Input
              id='input-phone-profile-data'
              label='Telefone'
              className='col-12 col-md-6 mt-2'
              mask={[
                '(',
                /[1-9]/,
                /\d/,
                ')',
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/,
                /\d/,
                /\d/
              ]}
              name='phone'
              onChange={this.handleInputChange}
              value={this.state.phone.value}
              disabled={this.state.phone.disabled === 'true'}
              onBlur={this.isValid}
            />

            <div className='col-12 offset-md-6 col-md-6 mt-2 d-none d-md-block'>
              <Button
                className='btn btn-sm btn-featured'
                disabled={!this.state.isValid}
                onClick={this.handleConfirm}
                text='Próximo'
              />
            </div>

            <div className='float-button bg-white px-2 py-2 row mx-0 d-block d-md-none'>
              <div className='col-12 px-0'>
                <Button
                  className='btn btn-sm btn-featured'
                  disabled={!this.state.isValid}
                  onClick={this.handleConfirm}
                  text='Próximo'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const valueType = PropTypes.shape({
  value: PropTypes.string.isRequired,
  disabled: PropTypes.string.isRequired
})

ProfileInfos.propTypes = {
  participant: PropTypes.shape({
    name: valueType,
    cpf: valueType,
    email: valueType,
    birthDate: valueType,
    phones: PropTypes.object,
    genderType: PropTypes.object
  }).isRequired,
  setCustomer: PropTypes.func.isRequired,
  buildPhone: PropTypes.func.isRequired
}

export default ProfileInfos



// WEBPACK FOOTER //
// ./src/features/Checkout/ProfileInfos/Individual.js